import { render, staticRenderFns } from "./DormBuildingAttendance.vue?vue&type=template&id=635569fa&scoped=true"
import script from "./DormBuildingAttendance.vue?vue&type=script&lang=js"
export * from "./DormBuildingAttendance.vue?vue&type=script&lang=js"
import style0 from "./DormBuildingAttendance.vue?vue&type=style&index=0&id=635569fa&prod&scoped=true&lang=css"
import style1 from "./DormBuildingAttendance.vue?vue&type=style&index=1&id=635569fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635569fa",
  null
  
)

export default component.exports